<div
  [ngClass]="{
    invisible:
      selectedPanel != panel.Image &&
      selectedPanel != panel.None &&
      !dataTable?.addingSpot,
  }"
>
  <cl-image-upload-info
    [width]="300"
    [height]="150"
    [left]="10"
    [top]="10"
    [rowId]="row?.rowId"
    [actionType]="action"
    [imageId]="imageId"
    [imageList]="imagesList"
    *ngIf="row || showImageOptions"
    (cancel)="setRow(null)"
    (imageChanged)="imageChanged($event)"
  >
    ></cl-image-upload-info
  >
  <button
    matTooltip="Add Image"
    matTooltipClass="blue white-background"
    mat-icon-button
    *ngIf="
      (!images || !images.length) &&
      checkRoles() &&
      !editor &&
      !builder &&
      !disabled
    "
    (click)="!disabled ? showImageDialog() : null"
  >
    <mat-icon color="primary">add_photo_alternate</mat-icon>
  </button>
  <div class="container-fluid overflow-hidden">
    <div class="row">
      <div #containerCanvas class="col-12 p-0">
        <canvas
          #mycanvas
          width="0"
          height="0"
          class="canva"
          [ngClass]="{ adding: dataTable?.addingSpot ?? false }"
          (click)="!disabled ? imageClicked($event) : null"
        ></canvas>
      </div>
    </div>
  </div>
</div>

<cl-image-upload-table
  #mytable
  [ngClass]="{
    invisible:
      (selectedPanel != panel.Table &&
        selectedPanel != panel.History &&
        selectedPanel != panel.None) ||
      (dataTable?.addingSpot ?? false),
  }"
  [disabled]="disabled || selectedPanel == 3"
  [configuration]="configuration"
  [compareConfiguration]="compareConfiguration"
  [editor]="editor ?? false"
  [builder]="builder ?? false"
  [enableColumnsBuilder]="enableColumnsBuilder"
  (newRow)="addRow($event)"
  (rowDeleted)="deleteRow($event)"
  (rowDuplicated)="duplicateRow($event)"
  (spotDeleted)="deleteSpot($event)"
  (tableChanged)="tableChange($event)"
  [canEdit]="checkRoles() && !disabled"
  (setRow)="setRow($event)"
  [history]="selectedPanel == panel.History"
></cl-image-upload-table>

<rads-table-history
  *ngIf="!disabled"
  [ngClass]="{ invisible: selectedPanel != panel.History }"
  [checklistSerialNo]="checklist?.serialNo ?? checklistTemplate?.serialNo ?? ''"
  [taskID]="taskID ?? 0"
  [configuration]="configuration"
  (selected)="historySelected($event)"
  (revertTo)="historyRevertTo($event)"
></rads-table-history>
